import { useTheme } from '../lib/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from './ui/tooltip';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const { t } = useTranslation();
    const isDark = theme === 'dark';
    const label = isDark ? t('common.switchToLightMode') : t('common.switchToDarkMode');

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={toggleTheme}
                        className="w-9 h-9 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
                        data-testid="theme-toggle-btn"
                    >
                        {isDark ? (
                            <Sun className="w-5 h-5 text-amber-500" />
                        ) : (
                            <Moon className="w-5 h-5 text-muted-foreground" />
                        )}
                        <span className="sr-only">
                            {label}
                        </span>
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{label}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default ThemeToggle;
